var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
      class: ["action", { gold: _vm.favored, loading: _vm.calling }],
      attrs: {
        href: "#",
        title: _vm.favored
          ? "Von Merkliste entfernen"
          : "Zu Merkliste hinzufügen"
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        }
      }
    },
    [_c("Icon", { attrs: { icon: "star" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }